import { render } from "./TextInputResponses.vue?vue&type=template&id=564f18a6&scoped=true&ts=true"
import script from "./TextInputResponses.vue?vue&type=script&lang=ts"
export * from "./TextInputResponses.vue?vue&type=script&lang=ts"

import "./TextInputResponses.vue?vue&type=style&index=0&id=564f18a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564f18a6"]])

export default __exports__